<template>
  <div>
    <label for="billing_month">
      Relatório
      <span class="m--font-danger">*</span>
    </label>
    <select
      class="form-control m-input"
      @select="emitChangeEvent"
      @change="emitChangeEvent"
    >
      <option value>{{ firstOption }}</option>
      <option
        v-for="m in options"
        :key="m.name"
        :value="m.component"
        :selected="m.name == selected"
      >
        {{ m.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { baseApiUrl } from '@/global';

export default {
  name: 'SelectReportGeneral',
  data() {
    return {
      firstOption: this.first ? this.first : 'Selecione',
      options: {
        0: {
          name: 'Desconto',
          component: 'ReportDiscounts',
        },
        1: {
          name: 'Descontos aplicados',
          component: 'ReportAppliedDiscount',
        },
        2: {
          name: 'Contratos',
          component: 'ReportContracts',
        },
        3: {
          name: 'Faturas',
          component: 'ReportInvoices',
        },
        4: {
          name: 'Histórico de Processamento',
          component: 'ReportProcessingHistory',
        },
        5: {
          name: 'Clientes',
          component: 'ReportCustomers',
        },
        6: {
          name: 'Ativos',
          component: 'ReportActives',
        },
        7: {
          name: 'Chatbots sem consumo',
          component: 'ReportContractsChatbotNoConsumption',
        },
        8: {
          name: 'Relação Griffin x Mktzap',
          component: 'ReportRelationGriffinMktzap',
        },
        9: {
          name: 'Relatório Analítico de consumos',
          component: 'ReportConsumptionAnalytics',
        },
        10: {
          name: 'Contratos (analítico)',
          component: 'ReportContractsAnalytical',
        },
        11: {
          name: 'Relatório de Contratos Reajustados',
          component: 'ReportContractsReadjustment',
        },
        12: {
          name: 'Clientes Cnae',
          component: 'ReportCustomersCnae',
        },
        13: {
          name: 'Relatório Analítico de Faturamento',
          component: 'ReportInvoiceAnalytics',
        },
        14: {
          name: 'Relatório de Alterações de Contrato',
          component: 'ReportContractsChange',
        },
        15: {
          name: 'Relatório Analítico de Faturamento (Quantidades)',
          component: 'ReportInvoiceAnalyticConsumptions',
        },
        16: {
          name: 'Relatório Analítico de Faturamento por Grupo de Clientes',
          component: 'ReportInvoiceAnalyticsByGroup',
        },
        17: {
          name: 'Relatório de comparações de clientes ativos Mktzap x Griffin',
          component: 'ReportCustomerGriffinMktzap',
        },
        18: {
          name: 'Relatório de contatos e atendimentos por cliente',
          component: 'ReportCustomerAttendanceProtocol',
        },
        19: {
          name: 'Faturas por categorias',
          component: 'ReportInvoiceCategories',
        },
        20: {
          name: 'Relatório Analítico de Faturamento Geral',
          component: 'ReportInvoiceAnalyticsGeneral',
        },
        21: {
          name: 'Relatório Dados Mensais (Faturamento Willis)',
          component: 'ReportMonthlyData',
        },
        22: {
          name: 'Consumo de Fatura Parcial',
          component: 'ReportPartialInvoiceConsumption',
        },
      },
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
};
</script>
